<template>
  <PCadastroRapido />
</template>

<script>
import PCadastroRapido from '@/components/p-cadastro-rapido/index.vue';

export default {
  components: {
    PCadastroRapido,
  },
};
</script>
